import { MENU_EMOJIS } from 'modules/map/components/daily-dish/look/emojiCatalog';

const emoji = MENU_EMOJIS;
/**
 * @param fontId
 *
 * @returns  Font family mapping
 */
export const getFontFamily = (fontId: number): string => {
  const fontMap: Record<number, string> = {
    1: "'Be Vietnam Pro', sans-serif",
    2: "'Montserrat', sans-serif",
    3: "'Poppins', sans-serif",
    4: "'Times New Roman', serif",
    5: "'Arial', sans-serif",
    6: "'Bungee', cursive",
    7: "'Dancing Script', cursive",
    8: "'Pacifico', cursive",
    9: "'Bangers', cursive",
    10: "'Goldman', cursive",
    11: "'Pangolin', cursive",
    12: "'Potta One', cursive",
    13: "'Bungee Inline', cursive",
    14: "'Agbalumo', cursive",
    15: "'Cherry Bomb', cursive",
    16: "'UTM Seagull', sans-serif",
    17: "'UTM Bebas', sans-serif",
    18: "'UTM Cooper Black', serif",
    19: "'UTM Cafeta', sans-serif",
    20: "'UTM Nokia Standard Bold', sans-serif",
  };
  return fontMap[fontId] || "'Arial', sans-serif";
};

/**
 * @param emojiId
 * @returns Emoji string
 */
export const getEmoji = (emojiId: number): string | null => {
  // emojiId is 1-based, array is 0-based
  return emoji[emojiId - 1] || null;
};

/**
 * @param iconId
 * @returns Icon mapping (deprecated, use getEmoji instead)
 */
export const getIconComponent = (iconId: number) => {
  // For backward compatibility, but should use getEmoji
  const emojiString = getEmoji(iconId);
  if (!emojiString) return null;

  // Return a component that renders the emoji
  return ({ sx }: { sx?: any }) => (
    <span style={{ fontSize: sx?.fontSize || '24px' }}>{emojiString}</span>
  );
};
